import { render, staticRenderFns } from "./account-group.vue?vue&type=template&id=3478ee9a&"
import script from "./account-group.vue?vue&type=script&lang=js&"
export * from "./account-group.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports